import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { FaHome, FaBook } from 'react-icons/fa';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-indigo-900 to-purple-900 text-white flex flex-col items-center justify-center px-4">
      <Helmet>
        <title>Page Not Found | The Library Hub</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.div
          className="text-8xl md:text-[10rem] font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 leading-none"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6, type: 'spring', bounce: 0.4 }}
        >
          404
        </motion.div>

        <FaBook className="text-4xl text-blue-400 mx-auto mb-6 opacity-70" />

        <h1 className="text-2xl md:text-3xl font-semibold mb-3">Page Not Found</h1>
        <p className="text-gray-300 text-base md:text-lg mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
          >
            <FaHome />
            Back to Home
          </Link>
          <Link
            to="/libraries"
            className="inline-flex items-center justify-center gap-2 border border-blue-400 text-blue-300 font-semibold py-3 px-8 rounded-full hover:bg-white hover:bg-opacity-10 transition-colors duration-200"
          >
            Browse Libraries
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
